export const getNextValueMultiChoice = <T>({
  clickedValue,
  currentValue,
}: {
  clickedValue: T;
  currentValue: T[] | null;
}): T[] => {
  const nextValue = currentValue ?? [];
  if (!currentValue || !currentValue.includes(clickedValue)) {
    nextValue.push(clickedValue);
  } else {
    nextValue.splice(currentValue.indexOf(clickedValue), 1);
  }

  return nextValue;
};

export const getNextValueSingleChoice = <T>({
  clickedValue,
  currentValue,
}: {
  clickedValue: T;
  currentValue: T | null;
}): T | null => {
  let nextValue;
  if (currentValue === clickedValue) {
    nextValue = null;
  } else {
    nextValue = clickedValue;
  }

  return nextValue;
};
